import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OutgoingDocs  {
    _originalTypeClassName = "zERP.BO.OutgoingDocs";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OutgoingDocs.translate = translateService;
}
this.OutgoingDocsKey = null;
this._key = this.OutgoingDocsKey = 0; 
}

static translate: TranslateService;
_key: any;
private _OutgoingDocsKey:any;
get OutgoingDocsKey(): any {
    return this._OutgoingDocsKey;
  }
set OutgoingDocsKey(value: any) {
    this._OutgoingDocsKey = value;
    this._key = value;
  }

static FillExpensesClassificationMultipleLines(invoice: any): any{let invoiceClassificationType;
invoiceClassificationType.invoiceMark = invoice?.Mark;
for (let _idetail = 0; _idetail < (invoice?.InvoiceDetails == null ? 0 : invoice?.InvoiceDetails.length); _idetail++) {let detail = invoice?.InvoiceDetails[_idetail];let ecd;ecd.lineNumber = detail?.LineNumber;for (let _iexpensesClassification = 0; _iexpensesClassification < (detail?.ExpensesClassification == null ? 0 : detail?.ExpensesClassification.length); _iexpensesClassification++) {let expensesClassification = detail?.ExpensesClassification[_iexpensesClassification];let ect;ect.amount = expensesClassification?.Amount;ect.classificationCategory = Domain.TransformHelper.MatchInterfaceExpensesClassificationCategory(expensesClassification?.ClassificationCategory);ect.classificationType = expensesClassification?.ClassificationType?.CodeStr;ecd.expensesClassificationDetailData?.add(ect);}for (let _iexpensesClassification = 0; _iexpensesClassification < (detail?.ExpensesVATClassification == null ? 0 : detail?.ExpensesVATClassification.length); _iexpensesClassification++) {let expensesClassification = detail?.ExpensesVATClassification[_iexpensesClassification];let ect;ect.amount = expensesClassification?.Amount;ect.classificationCategory = Domain.TransformHelper.MatchInterfaceExpensesClassificationCategory(expensesClassification?.ClassificationCategory);ect.classificationType = expensesClassification?.ClassificationType?.CodeStr;ecd.expensesClassificationDetailData?.add(ect);}invoiceClassificationType.invoicesExpensesClassificationDetails?.add(ecd);}
return invoiceClassificationType;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OutgoingDocsKey == null || $this.OutgoingDocsKey == 0;
            }


}